import { updatesData } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          平台更新、专题策划与内容公告，不错过每一次精彩
        </p>
        <div className="relative">
          <div className="absolute left-[15px] top-2 bottom-2 w-px bg-primary-200/60 hidden sm:block"></div>
          <div className="space-y-6">
            {updatesData.map((item) => (
              <div key={item.id} className="flex gap-4 sm:gap-6">
                <div className="hidden sm:flex flex-shrink-0 w-8 h-8 rounded-full bg-primary-100 border-2 border-primary-300 items-center justify-center relative z-10">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                </div>
                <div className="flex-1 bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/60">
                  <span className="inline-block text-xs text-primary-600 font-medium mb-2">{item.date}</span>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}